<template>
  <div class="bg-[whitesmoke] h-full w-full text-center py-3">
    <h2>From Sample Layout</h2>
    <slot />
  </div>
</template>
